import React, { useState, useEffect } from 'react';
import Swal from "sweetalert2";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faEdit, faTrash, faWrench } from '@fortawesome/free-solid-svg-icons';

import { FormInput_text, FormInput_textarea, Dropdown, formInput_funcUtility, Datepicker, Spinner, Toaster } from "components";

import { func_validation, func_currency, func_cookieSetting, func_datetime } from 'functions';

import { color_failure } from "assets/scss/partials/_colors.scss";
import moment from 'moment';


export default function RecursiveBillingSetupColumns(props) {
    const {
        setAccountCode: setAccountCode_props, setIsModalVisible_remarks
    } = props;

    let isUserInputsVisible_props = func_validation.getObjectPropertyValue(props, "isUserInputsVisible");
    let isAddingAccountFunction = func_validation.getObjectPropertyValue(props, "isAddingAccountFunction");
    let addAccount_requesting = func_validation.getObjectPropertyValue(props, "addAccount_requesting");
    let isUpdateAccountFunction = func_validation.getObjectPropertyValue(props, "isUpdateAccountFunction");
    let isActionSuccessful = func_validation.getObjectPropertyValue(props, "isActionSuccessful");
    let handleRowClickability = () => {};
    if (func_validation.isObjectNotEmpty(props)) {
        if (func_validation.isFunction(props.handleRowClickability)) handleRowClickability = props.handleRowClickability;
    }

    // States

    const [companyId, setCompanyId] = useState("");
    const [accountCode, setAccountCode] = useState("");
    const [dealerCode, setDealerCode] = useState("");
    const [salesPersonCode, setSalesPersonCode] = useState("");
    const [productCode, setProductCode] = useState("");
    const [productName, setProductName] = useState("");
    const [isDefaultProduct, setIsDefaultProduct] = useState("");
    const [chargeMethod, setChargeMethod] = useState("");
    const [posCountToCharge, setPosCountToCharge] = useState("");
    const [systemChargeMethodComment, setSystemChargeMethodComment] = useState("");
    const [subscriptionMethod, setSubscriptionMethod] = useState("");
    const [frequency, setFrequency] = useState("");
    const [unitPrice, setUnitPrice] = useState("");
    const [quantity, setQuantity] = useState("");
    const [isAdvancePay, setIsAdvancePay] = useState("");
    const [unitDiscountAmount, setUnitDiscountAmount] = useState("");
    const [isBillInForeignCurrency, setIsBillInForeignCurrency] = useState("");
    const [currencyCode, setCurrencyCode] = useState("");
    const [currencyRate, setCurrencyRate] = useState("");
    const [transactionCountToCharge, setTransactionCountToCharge] = useState("");
    
    let currentDate_toString = moment().format("YYYY-MM-DD");
    const [lastBilledDatetime, setLastBilledDatetime] = useState("");
    const [nextBilledDatetime, setNextBilledDatetime] = useState("");
    const [lastBilledDateDay, setLastBilledDateDay] = useState("");
    const [cutOffDate, setCutOffDate] = useState("");

    const [isSuspense, setIsSuspense] = useState("");
    const [referenceValue, setReferenceValue] = useState("");
    const [remarks, setRemarks] = useState("");

    const [isFormSubmissionAttempted, setFormSubmissionStatus] = useState(false);
    const [inputVisibility_rowIndex, setInputVisibility_rowIndex] = useState(0);

    const [isUserInputsVisible, setIsUserInputsVisible] = useState(false);
    const [isDefaultInputValuesSet, setIsDefaultInputValuesSet] = useState(false);

    const [selectedRowIdx, setSelectedRowIdx] = useState();


    useEffect(() => {
        setIsUserInputsVisible(isUserInputsVisible_props);
    }, [isUserInputsVisible_props]);


    // Hide user input after action is successful
    useEffect(() => {
        if (isActionSuccessful) {
            setIsUserInputsVisible(false);
            setIsUserInputsVisible(false);
            handleRowClickability(undefined);
            resetAllStates();
        }
    }, [isActionSuccessful]);

    // Reset all states
    function resetAllStates() {
        setCompanyId("");
        setAccountCode("");
        setDealerCode("");
        setSalesPersonCode("");
        setProductCode("");
        setProductName("");
        setIsDefaultProduct("");
        setChargeMethod("");
        setSystemChargeMethodComment("");
        setSubscriptionMethod("");
        setFrequency("");
        setUnitPrice("");
        setQuantity("");
        setIsAdvancePay("");
        setUnitDiscountAmount("");
        setIsBillInForeignCurrency("");
        setCurrencyCode("");
        setCurrencyRate("");
        setTransactionCountToCharge("");
        setLastBilledDatetime("");
        setNextBilledDatetime("");
        setLastBilledDateDay("");
        setCutOffDate("");
        setIsSuspense("");
        setReferenceValue("");
        setRemarks("");
        setFormSubmissionStatus(false);
    }

    function posCountToCharge_onClick() {
        if (!func_validation.isStringEqual_caseInsensitive(chargeMethod, "OutletPos"))
            Toaster({
                type: "info",
                msg: "Please set Charge Method as Outlet POS."
            });
    }
    function posCountToCharge_updateStates() {
        if (!func_validation.isStringEqual_caseInsensitive(chargeMethod, "OutletPos")) setPosCountToCharge("");
    }
    useEffect(() => {
        posCountToCharge_updateStates();
    }, [chargeMethod]);

    function systemChargeMethodComment_onClick() {
        if (!func_validation.isStringEqual_caseInsensitive(chargeMethod, "System"))
            Toaster({
                type: "info",
                msg: "Please set Charge Method as System."
            })
    }
    function systemChargeMethodComment_updateStates() {
        if (!func_validation.isStringEqual_caseInsensitive(chargeMethod, "System")) setSystemChargeMethodComment("");
    }
    useEffect(() => {
        systemChargeMethodComment_updateStates();
    }, [chargeMethod]);

    // Columns

    function getColumns_companyId() {
        let columnClassName = "recursiveBillingSetup-companyId";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Company ID",
            // isHeaderColumnSortable: true,
            // sortValue: "companyId",
            id: "companyId",
            accessor: "CompanyId",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;
    
                let value = props?.cell?.value;
                let value_formatted = func_validation.isNumberValid(value)? value: "-";
                value_formatted = (rowDepth == 1)? "": value_formatted;

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        (value_formatted != "-")) {
                        setCompanyId(value_formatted + "");
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setCompanyId("");
                    }
                }, [isUserInputDisplayVisible]);

                let display = isUserInputDisplayVisible? (
                    <FormInput_text  
                        customInputClassName={" recursiveBillingSetup-companyId-input "}
                        inputValue_default={companyId} 

                        isInputBlurHandlingRequired
                        handleInputBlurExtend={(value) => { setCompanyId(value); }}

                        inputMaxLength={64} 
                        isFormSubmissionAttempted={isFormSubmissionAttempted}
        
                        isLabelOptional isInputValueTrim_onChange
                        isMarginBtmOptional isErrorMsgOptional isInputDigitOnly
                    />
                ): (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );

                return display;
            },
        }
    }

    function getColumns_accountCode() {
        let columnClassName = "recursiveBillingSetup-accountCode";
        
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Account Code",
            // isHeaderColumnSortable: true,
            // sortValue: "accountCode",
            id: "accountCode",
            accessor: "AccountCode",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;
    
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
                value_formatted = (rowDepth == 1)? "": value_formatted;

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        (value_formatted != "-")) {

                        setAccountCode(value_formatted + "");
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setAccountCode("");
                    }
                }, [isUserInputDisplayVisible]);
    
                let display = isUserInputDisplayVisible? (
                    <FormInput_text  
                        customInputClassName={" recursiveBillingSetup-accountCode-input "}
                        inputValue_default={accountCode} 

                        isInputBlurHandlingRequired
                        handleInputBlurExtend={(value) => { setAccountCode(value); }}

                        inputMaxLength={64} 
                        isFormSubmissionAttempted={isFormSubmissionAttempted} 
        
                        isLabelOptional isInputValueTrim_onChange
                        isMarginBtmOptional isErrorMsgOptional
                    />
                ):(
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                )

                return display;
            },
        }
    }

    function getColumns_dealerCode() {
        let columnClassName = "recursiveBillingSetup-dealerCode";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Dealer Code",
            // isHeaderColumnSortable: true,
            // sortValue: "dealerCode",
            id: "dealerCode",
            accessor: "DealerCode",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;
    
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
                value_formatted = (rowDepth == 1)? "": value_formatted;

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        (value_formatted != "-")) {
                        setDealerCode(value_formatted + "");
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setDealerCode("");
                    }
                }, [isUserInputDisplayVisible]);
    
                let display = isUserInputDisplayVisible? (
                    <FormInput_text  
                        customInputClassName={" recursiveBillingSetup-dealerCode-input "}
                        inputValue_default={dealerCode} 

                        isInputBlurHandlingRequired
                        handleInputBlurExtend={(value) => { setDealerCode(value); }}

                        inputMaxLength={64} 
        
                        isLabelOptional isInputValueTrim_onChange
                        isMarginBtmOptional isErrorMsgOptional
                    />
                ):(
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                )

                return display;
            },
        }
    }

    function getColumns_salesPersonCode() {
        let columnClassName = "recursiveBillingSetup-salesPersonCode";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Sales Person Code",
            // isHeaderColumnSortable: true,
            // sortValue: "salesPersonCode",
            id: "salesPersonCode",
            accessor: "SalesPersonCode",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;
    
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
                value_formatted = (rowDepth == 1)? "": value_formatted;

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        (value_formatted != "-")) {
                        setSalesPersonCode(value_formatted + "");
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setSalesPersonCode("");
                    }
                }, [isUserInputDisplayVisible]);

                let display = isUserInputDisplayVisible? (
                    <FormInput_text  
                        customInputClassName={" recursiveBillingSetup-salesPersonCode-input "}
                        inputValue_default={salesPersonCode} 

                        isInputBlurHandlingRequired
                        handleInputBlurExtend={(value) => { setSalesPersonCode(value); }}

                        inputMaxLength={64} 
        
                        isLabelOptional isInputValueTrim_onChange
                        isMarginBtmOptional isErrorMsgOptional
                    />
                ):(
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                )
                
                return display;
            },
        }
    }

    function getColumns_productCode() {
        let columnClassName = "recursiveBillingSetup-productCode";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Product Code",
            // isHeaderColumnSortable: true,
            // sortValue: "productCode",
            id: "productCode",
            accessor: "ProductCode",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;
    
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
                value_formatted = (rowDepth == 1)? "": value_formatted;

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        (value_formatted != "-")) {
                        setProductCode(value_formatted + "");
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setProductCode("");
                    }
                }, [isUserInputDisplayVisible]);

                let display = isUserInputDisplayVisible? (
                    <FormInput_text  
                        customInputClassName={" recursiveBillingSetup-productCode-input "}
                        inputValue_default={productCode} 

                        isInputBlurHandlingRequired
                        handleInputBlurExtend={(value) => { setProductCode(value); }}

                        inputMaxLength={64} 
                        isFormSubmissionAttempted={isFormSubmissionAttempted} 
        
                        isLabelOptional
                        isMarginBtmOptional isErrorMsgOptional
                    />
                ):(
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                )

                return display;
            },
        }
    }

    function getColumns_productName() {
        let columnClassName = "recursiveBillingSetup-productName";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Product Name",
            // isHeaderColumnSortable: true,
            // sortValue: "productName",
            id: "productName",
            accessor: "ProductName",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;
    
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
                value_formatted = (rowDepth == 1)? "": value_formatted;

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        (value_formatted != "-")) {
                        setProductName(value_formatted + "");
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setProductName("");
                    }
                }, [isUserInputDisplayVisible]);

                let display = isUserInputDisplayVisible? (
                    <FormInput_text  
                        customInputClassName={" recursiveBillingSetup-productName-input "}
                        inputValue_default={productName} 

                        isInputBlurHandlingRequired
                        handleInputBlurExtend={(value) => { setProductName(value); }}

                        isFormSubmissionAttempted={isFormSubmissionAttempted} 
        
                        isLabelOptional
                        isMarginBtmOptional isErrorMsgOptional
                    />
                ):(
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                )

                return display;
            },
        }
    }

    function getColumns_isDefaultProduct() {
        let columnClassName = "recursiveBillingSetup-isDefaultProduct";

        let options = [ 
            {
                label: "Yes",
                value: true
            },
            {
                label: "No",
                value: false
            }
        ];

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Is Default Product",
            // isHeaderColumnSortable: true,
            // sortValue: "isDefaultProduct",
            id: "isDefaultProduct",
            accessor: "IsDefaultProduct",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {                
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;
    
                let value = props?.cell?.value;
                let value_formatted = func_validation.isNotNullUndefined(value)? value: "-";
                value_formatted = (rowDepth == 1)? "": value_formatted;

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        (value_formatted != "-")) {
                        setIsDefaultProduct(value_formatted);
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setIsDefaultProduct(false);
                    }
                }, [isUserInputDisplayVisible]);

                let display = isUserInputDisplayVisible? (
                    <Dropdown
                        selectedValueWrapperClassName={" recursiveBillingSetup-isDefaultProduct-input "}
                        selectedValueClassName={"recursiveBillingSetup-isDefaultProduct-inputText"}

                        options={options}
                        selectedValue_default={isDefaultProduct}
                        onChange={setIsDefaultProduct}
                        isFormSubmissionAttempted={isFormSubmissionAttempted}
                        
                    />
                ):(
                    <div  className={"noWrap-text-ellipsis"}>{func_validation.getUserFriendlyTrueFalseDisplay(value_formatted)}</div>
                )

                return display;
            },
        }
    }
    
    function getColumns_posCountToCharge() {
        let columnClassName = "recursiveBillingSetup-posCountToCharge justify-content-center";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "POS Count to Charge",
            // isHeaderColumnSortable: true,
            // sortValue: "posCountToCharge",
            id: "posCountToCharge",
            accessor: "POSCountToCharge",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;

                let value = props?.cell?.value;
                let value_formatted = func_validation.isNumberValid(value)? value: "-";
                value_formatted = (rowDepth == 1)? "": value_formatted;

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        (value_formatted != "-")) {
                            
                        setPosCountToCharge(parseInt(value_formatted + ""));
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setPosCountToCharge(0);
                    }
                }, [isUserInputDisplayVisible]);

                let display = isUserInputDisplayVisible? (
                    <FormInput_text  
                        customInputClassName={"recursiveBillingSetup-posCountToCharge-input "}
                        inputValue_default={posCountToCharge}
                        isInputOptional

                        handleInputClickExtend={posCountToCharge_onClick}
                        isInputClickHandlingRequired

                        handleInputBlurExtend={(value) => { setPosCountToCharge(value); }}
                        isInputBlurHandlingRequired
        
                        inputMaxLength={64} 

                        customErrorMsgDefault={"Input required to be greater than 0"}
                        customErrorValidation={func_validation.isStringEqual_caseInsensitive(chargeMethod, "OutletPos") &&
                            (!func_validation.isNumberWithinRange(posCountToCharge, { min: 1 })) &&
                            isFormSubmissionAttempted}
        
                        isLabelOptional isInputValueTrim_onChange
                        isMarginBtmOptional isInputDigitOnly isConvertedToNumber
                        inputCustomOptions={{ readOnly: (!func_validation.isStringEqual_caseInsensitive(chargeMethod, "OutletPos")) }}
                    />
                ):(
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                )

                return display;
            },
        }
    }

    function getColumns_chargeMethod() {
        let columnClassName = "recursiveBillingSetup-chargeMethod";

        let options = [
            {
                label: "License",
                value: "License"
            },
            {
                label: "Outlet",
                value: "Outlet"
            },
            {
                label: "System",
                value: "System"
            },
            {
                label: "Outlet POS",
                value: "OutletPos"
            },
            {
                label: "Outlet Transaction",
                value: "OutletTransaction"
            },
        ];

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Charge Method",
            // isHeaderColumnSortable: true,
            // sortValue: "chargeMethod",
            id: "chargeMethod",
            accessor: "ChargeMethod",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;
    
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
                value_formatted = (rowDepth == 1)? "": value_formatted;

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        (value_formatted != "-")) {
                        setChargeMethod(value_formatted + "");
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setChargeMethod("OutletTransaction");
                    }
                }, [isUserInputDisplayVisible]);

                let display = isUserInputDisplayVisible? (
                    <Dropdown
                        selectedValueWrapperClassName={" recursiveBillingSetup-chargeMethod-input "}
                        selectedValueClassName={"recursiveBillingSetup-chargeMethod-inputText"}

                        options={options}
                        selectedValue_default={chargeMethod}
                        onChange={setChargeMethod}
        
                        isFormSubmissionAttempted={isFormSubmissionAttempted}

                        customErrorValidation={isFormSubmissionAttempted && 
                            (func_validation.isStringTrimNotEmpty(systemChargeMethodComment) && (!func_validation.isStringEqual_caseInsensitive(chargeMethod, "System")))}
                        
                        
                    />
                ):(
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                )
                
                return display;
            },
        }
    }

    function getColumns_systemChargeMethodComment() {
        let columnClassName = "recursiveBillingSetup-systemChargeMethodComment";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "System Charge Method Comment",
            // isHeaderColumnSortable: true,
            // sortValue: "systemChargeMethodComment",
            id: "systemChargeMethodComment",
            accessor: "SystemChargeMethodComment",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;

                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value:"-";
                value_formatted = (rowDepth == 1)? "": value_formatted;

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        (value_formatted != "-")) {
                        setSystemChargeMethodComment(value_formatted + "");
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setSystemChargeMethodComment("");
                    }
                }, [isUserInputDisplayVisible]);

                let display = isUserInputDisplayVisible? (
                    <FormInput_textarea
                        customInputClassName={" recursiveBillingSetup-systemChargeMethodComment-input "}
                        inputValue={systemChargeMethodComment}
                        isInputOptional
    
                        handleInputClickExtend={systemChargeMethodComment_onClick}
                        isInputClickHandlingRequired
    
                        isInputBlurHandlingRequired
                        handleInputBlurExtend={(value) => { setSystemChargeMethodComment(value); }}
    
                        isMarginBtmOptional isErrorMsgOptional
                        inputCustomOptions={{ readOnly: (!func_validation.isStringEqual_caseInsensitive(chargeMethod, "System")) }}
                    />
                ):(
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                )

                return display;
            },
            width: 250
        }
    }

    function getColumns_subscriptionMethod() {
        let columnClassName = "recursiveBillingSetup-subscriptionMethod";

        let options = ["Monthly", "Daily"];
        options = func_validation.convertArrayToDropdownArrayFormat(options);

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Subscription Method",
            // isHeaderColumnSortable: true,
            // sortValue: "subscriptionMethod",
            id: "subscriptionMethod",
            accessor: "SubscriptionMethod",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;
    
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
                value_formatted = (rowDepth == 1)? "": value_formatted;

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        (value_formatted != "-")) {
                        setSubscriptionMethod(value_formatted + "");
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setSubscriptionMethod("Monthly");
                    }
                }, [isUserInputDisplayVisible]);

                let display = isUserInputDisplayVisible? (
                    <Dropdown
                        selectedValueWrapperClassName={" recursiveBillingSetup-subscriptionMethod-input "}
                        selectedValueClassName={"recursiveBillingSetup-subscriptionMethod-inputText"}

                        options={options}
                        selectedValue_default={subscriptionMethod}
                        onChange={setSubscriptionMethod}
        
                        isFormSubmissionAttempted={isFormSubmissionAttempted}
                    />
                ):(
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                )

                return display;
            },
        }
    }

    function getColumns_frequency() {
        let columnClassName = "recursiveBillingSetup-frequency  justify-content-center";

        let options = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
        options = func_validation.convertArrayToDropdownArrayFormat(options);

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Frequecy / mth",
            // isHeaderColumnSortable: true,
            // sortValue: "frequency",
            id: "frequency",
            accessor: "BillFrequence",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;
    
                let value = props?.cell?.value;
                let value_formatted = func_validation.isNumberValid(value)? value: "-";
                value_formatted = (rowDepth == 1)? "": value_formatted;

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        (value_formatted != "-")) {
                        setFrequency(value_formatted);
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setFrequency(1);
                    }
                }, [isUserInputDisplayVisible]);

                let display = isUserInputDisplayVisible? (
                    <Dropdown
                        selectedValueWrapperClassName={" recursiveBillingSetup-frequency-input "}
                        selectedValueClassName={"recursiveBillingSetup-frequency-inputText"}

                        options={options}
                        selectedValue_default={frequency}
                        onChange={setFrequency}
                        isFormSubmissionAttempted={isFormSubmissionAttempted}
                        
                    />
                ):(
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                )

                return display;
            },
        }
    }

    function getColumns_unitPrice() {
        let columnClassName = "recursiveBillingSetup-unitPrice";

        return {
            headerCellClassName: columnClassName + " justify-content-start",
            Header: "Unit Price (RM)",
            // isHeaderColumnSortable: true,
            // sortValue: "unitPrice",
            id: "unitPrice",
            accessor: "UnitPrice",
            bodyCellClassName: columnClassName + " justify-content-end",
            Cell: (props) => {
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;
    
                let value = props?.cell?.value;
                let value_formatted = func_validation.isNumberValid(value)? value: "-";
                if (!func_validation.isStringEqual_caseInsensitive(value_formatted, "-")) 
                    value_formatted = func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true });
                value_formatted = (rowDepth == 1)? "": value_formatted;

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        (value_formatted != "-")) {
                        setUnitPrice(value_formatted + "");
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setUnitPrice("1.00");
                    }
                }, [isUserInputDisplayVisible]);

                let display = isUserInputDisplayVisible? (
                    <FormInput_text  
                        customInputClassName={" recursiveBillingSetup-unitPrice-input "}
                        inputValue_default={unitPrice} 

                        handleInputBlurExtend={(value) => { 
                            if (func_validation.isStringTrimNotEmpty(value)) setUnitPrice(value);
                            else setUnitPrice("");
                        }}

                        inputMaxLength={64} 
                        isFormSubmissionAttempted={isFormSubmissionAttempted} 
        
                        handleInputFocusExtend={(e)=>{ formInput_funcUtility.handleInputFocus_onEnter_selectInput(e); }}
                        isValuePropagationGuarded_onChange={(value)=>{ return (value.match(func_validation.getRegexMatchCurrencyDoublePrecisionCaseInsensitive()) || value == '') }}
                        customValidator_onBlur={(value)=>{ return func_currency.validateStringDoublePrecisionCurrency(value, '1.00'); }}
        
                        isLabelOptional isInputValueTrim_onChange 
                        isInputBlurHandlingRequired isInputValueTrim_onBlur
                        isMarginBtmOptional isErrorMsgOptional
                    />
                ):(
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                )

                return display;
            },
        }
    }

    function getColumns_quantity() {
        let columnClassName = "recursiveBillingSetup-quantity justify-content-center";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Quantity",
            // isHeaderColumnSortable: true,
            // sortValue: "quantity",
            id: "quantity",
            accessor: "Quantity",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;

                let value = props?.cell?.value;
                let value_formatted = func_validation.isNumberValid(value)? value: "-";
                value_formatted = (rowDepth == 1)? "": value_formatted;

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        (value_formatted != "-")) {
                        setQuantity(value_formatted + "");
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setQuantity("0");
                    }
                }, [isUserInputDisplayVisible]);

                let display = isUserInputDisplayVisible? (
                    <FormInput_text  
                        customInputClassName={" recursiveBillingSetup-quantity-input "}
                        inputValue_default={quantity} 

                        isInputBlurHandlingRequired
                        handleInputBlurExtend={(value) => { setQuantity(value); }}
        
                        inputMaxLength={64} 
                        isFormSubmissionAttempted={isFormSubmissionAttempted} 
        
                        isLabelOptional isInputValueTrim_onChange
                        isMarginBtmOptional isErrorMsgOptional isInputDigitOnly isConvertedToNumber
                    />
                ):(
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                )

                return display;
            },
        }
    }

    function getColumns_advancePay() {
        let columnClassName = "recursiveBillingSetup-isAdvancePay";

        let options = [ 
            {
                label: "Yes",
                value: true
            },
            {
                label: "No",
                value: false
            }
        ];

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Is Advance Pay",
            // isHeaderColumnSortable: true,
            // sortValue: "isAdvancePay",
            id: "isAdvancePay",
            accessor: "IsAdvancePay",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {                
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;
    
                let value = props?.cell?.value;
                let value_formatted = func_validation.isNotNullUndefined(value)? value: "-";
                value_formatted = (rowDepth == 1)? "": value_formatted;

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        (value_formatted != "-")) {
                        setIsAdvancePay(value_formatted);
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setIsAdvancePay(false);
                    }
                }, [isUserInputDisplayVisible]);

                let display = isUserInputDisplayVisible? (
                    <Dropdown
                        selectedValueWrapperClassName={" recursiveBillingSetup-isAdvancePay-input "}
                        selectedValueClassName={"recursiveBillingSetup-isAdvancePay-inputText"}

                        options={options}
                        selectedValue_default={isAdvancePay}
                        onChange={setIsAdvancePay}
                        isFormSubmissionAttempted={isFormSubmissionAttempted}
                        
                    />
                ):(
                    <div  className={"noWrap-text-ellipsis"}>{func_validation.getUserFriendlyTrueFalseDisplay(value_formatted + "")}</div>
                )

                return display;
            },
        }
    }

    function getColumns_unitDiscountAmount() {
        let columnClassName = "recursiveBillingSetup-unitDiscountAmount";

        return {
            headerCellClassName: columnClassName + " justify-content-start",
            Header: "Unit Discount Amount (RM)",
            // isHeaderColumnSortable: true,
            // sortValue: "unitDiscountAmount",
            id: "unitDiscountAmount",
            accessor: "UnitDiscountAmount",
            bodyCellClassName: columnClassName + " justify-content-end",
            Cell: (props) => {
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;
    
                let value = props?.cell?.value;
                let value_formatted = func_validation.isNumberValid(value)? value: "-";
                if (!func_validation.isStringEqual_caseInsensitive(value_formatted, "-")) 
                    value_formatted = func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true });
                value_formatted = (rowDepth == 1)? "": value_formatted;

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        (value_formatted != "-")) {
                        setUnitDiscountAmount(value_formatted + "");
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setUnitDiscountAmount("0");
                    }
                }, [isUserInputDisplayVisible]);

                let display = isUserInputDisplayVisible? (
                    <FormInput_text  
                        customInputClassName={" recursiveBillingSetup-unitDiscountAmount-input "}
                        inputValue_default={unitDiscountAmount}

                        handleInputBlurExtend={(value) => { setUnitDiscountAmount(value); }}
        
                        inputMaxLength={64} 

                        handleInputFocusExtend={(e)=>{ formInput_funcUtility.handleInputFocus_onEnter_selectInput(e); }}
                        isValuePropagationGuarded_onChange={(value)=>{ return (value.match(func_validation.getRegexMatchCurrencyDoublePrecisionCaseInsensitive()) || value == '') }}
                        customValidator_onBlur={(value)=>{ return func_currency.validateStringDoublePrecisionCurrency(value, '0.00'); }}
        
                        isLabelOptional isInputValueTrim_onChange
                        isInputBlurHandlingRequired isInputValueTrim_onBlur
                        isMarginBtmOptional isErrorMsgOptional
                    />
                ):(
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                )

                return display;
            },
            width: 250
        }
    }

    function getColumns_isBillInForeignCurrency() {
        let columnClassName = "recursiveBillingSetup-isBillInForeignCurrency";

        let options = [ 
            {
                label: "Yes",
                value: true
            },
            {
                label: "No",
                value: false
            }
        ];

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Is Bill In Foreign Currency",
            // isHeaderColumnSortable: true,
            // sortValue: "isBillInForeignCurrency",
            id: "isBillInForeignCurrency",
            accessor: "IsBillInForeignCurrency",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;
    
                let value = props?.cell?.value;
                let value_formatted = func_validation.isNotNullUndefined(value)? value: "-";
                value_formatted = (rowDepth == 1)? "": value_formatted;

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);
                
                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        (value_formatted != "-")) {
                        setIsBillInForeignCurrency(value_formatted);
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setIsBillInForeignCurrency(false);
                    }
                }, [isUserInputDisplayVisible]);

                let display = isUserInputDisplayVisible? (
                    <Dropdown
                        selectedValueWrapperClassName={" recursiveBillingSetup-isBillInForeignCurrency-input "}
                        selectedValueClassName={"recursiveBillingSetup-isBillInForeignCurrency-inputText"}

                        options={options}
                        selectedValue_default={isBillInForeignCurrency}
                        onChange={setIsBillInForeignCurrency}
                        isFormSubmissionAttempted={isFormSubmissionAttempted}
                        
                    />
                ):(
                    <div  className={"noWrap-text-ellipsis"}>{func_validation.getUserFriendlyTrueFalseDisplay(value_formatted + "")}</div>
                )

                return display;
            },
            width: 250
        }
    }

    function getColumns_currencyCode() {
        let columnClassName = "recursiveBillingSetup-currencyCode";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Currency Code",
            // isHeaderColumnSortable: true,
            // sortValue: "currencyCode",
            id: "currencyCode",
            accessor: "CurrencyCode",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;
    
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
                value_formatted = (rowDepth == 1)? "": value_formatted;

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        (value_formatted != "-")) {
                        setCurrencyCode(value_formatted + "");
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setCurrencyCode("MYR");
                    }
                }, [isUserInputDisplayVisible]);

                let display = isUserInputDisplayVisible? (
                    <FormInput_text  
                        customInputClassName={" recursiveBillingSetup-currencyCode-input "}
                        inputValue_default={currencyCode} 

                        isInputBlurHandlingRequired
                        handleInputBlurExtend={(value) => { setCurrencyCode(value); }}

                        inputMaxLength={3} 
                        isFormSubmissionAttempted={isFormSubmissionAttempted} 
        
                        isLabelOptional isInputValueTrim_onChange
                        isMarginBtmOptional isErrorMsgOptional
                    />
                ):(
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                )

                return display;
            },
        }
    }

    function getColumns_currencyRate() {
        let columnClassName = "recursiveBillingSetup-currencyRate";

        return {
            headerCellClassName: columnClassName + " justify-content-start",
            Header: "Currency Rate",
            // isHeaderColumnSortable: true,
            // sortValue: "currencyRate",
            id: "currencyRate",
            accessor: "CurrencyRate",
            bodyCellClassName: columnClassName + " justify-content-end",
            Cell: (props) => {
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;
    
                let value = props?.cell?.value;
                let value_formatted = func_validation.isNumberValid(value)? value: "-";
                value_formatted = (rowDepth == 1)? "": value_formatted;

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        (value_formatted != "-")) {
                        setCurrencyRate(value_formatted + "");
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setCurrencyRate("");
                    }
                }, [isUserInputDisplayVisible]);

                let display = isUserInputDisplayVisible? (
                    <FormInput_text  
                        customInputClassName={" recursiveBillingSetup-currencyRate-input "}
                        inputValue_default={currencyRate} 

                        isInputBlurHandlingRequired
                        handleInputBlurExtend={(value) => { 
                            if (func_validation.isStringTrimNotEmpty(value)) setCurrencyRate(value);
                            else setCurrencyRate("");
                        }}

                        inputMaxLength={64} 

                        handleInputFocusExtend={(e)=>{ formInput_funcUtility.handleInputFocus_onEnter_selectInput(e); }}
                        isValuePropagationGuarded_onChange={(value)=>{ return (value.match(func_validation.getRegexMatchCurrencyDoublePrecisionCaseInsensitive()) || value == '') }}
                        customValidator_onBlur={(value)=>{ return func_currency.validateStringDoublePrecisionCurrency(value, '1.00'); }}
        
                        isLabelOptional isInputValueTrim_onChange 
                        isInputValueTrim_onBlur
                        isMarginBtmOptional isErrorMsgOptional
                    />
                ):(
                    <div className={"noWrap-text-ellipsis"}>
                        {(value_formatted != "-")?
                            func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true })
                        :""}
                    </div>
                )

                return display;
            },
        }
    }

    function getColumns_transactionCountToCharge() {
        let columnClassName = "recursiveBillingSetup-transactionCountToCharge justify-content-center";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Transaction Count To Charge",
            // isHeaderColumnSortable: true,
            // sortValue: "transactionCountToCharge",
            id: "transactionCountToCharge",
            accessor: "TransactionCountToCharge",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;
    
                let value = props?.cell?.value;
                let value_formatted = func_validation.isNumberValid(value)? value: "-";
                value_formatted = (rowDepth == 1)? "": value_formatted;

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        (value_formatted != "-")) {
                        setTransactionCountToCharge(parseInt(value_formatted + ""));
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setTransactionCountToCharge("");
                    }
                }, [isUserInputDisplayVisible]);

                let display = isUserInputDisplayVisible? (
                    <FormInput_text  
                        customInputClassName={" recursiveBillingSetup-transactionCountToCharge-input "}
                        inputValue={transactionCountToCharge} 
                        isInputOptional

                        isInputBlurHandlingRequired
                        handleInputBlurExtend={(value) => { setTransactionCountToCharge(value); }}
    
                        inputMaxLength={64} 
    
                        customErrorMsgDefault={"Required"}
                        customErrorValidation={func_validation.isStringEqual_caseInsensitive(chargeMethod, "OutletTransaction") &&
                            func_validation.isStringTrimEmpty(transactionCountToCharge) &&
                            isFormSubmissionAttempted}
    
                        isInputValueTrim_onChange
                        isMarginBtmOptional isInputDigitOnly isConvertedToNumber
                    />
                ):(
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                )

                return display;
            },
            width: 250
        }
    }

    function getColumns_lastBilledDatetime() {
        let columnClassName= "recursiveBillingSetup-lastBilledDatetime";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Last Billed Date",
            // isHeaderColumnSortable: true,
            // sortValue: "lastBilledDatetime",
            id: "lastBilledDatetime",
            accessor: "LastBilledDateTime",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;
    
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
                value_formatted = (rowDepth == 1)? "": value_formatted;
                let value_original = "";
                if (func_validation.isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) {
                    value_original = value_formatted;
                    value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");
                }

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        func_validation.isStringTrimNotEmpty(value_original)) {
                        setLastBilledDatetime(value_original);
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setLastBilledDatetime(currentDate_toString);
                    }
                }, [isUserInputDisplayVisible]);

                let display = isUserInputDisplayVisible? (
                    <div className={" recursiveBillingSetup-lastBilledDatetime-input "}>
                        <Datepicker
                            defaultDate={lastBilledDatetime}
                            handleOnChange={setLastBilledDatetime}
                            isConversionRequired_ISO8601
                        />
                    </div>
                ):(
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                )

                return display;
            },
        }
    }

    function getColumns_lastBilledDateDay() {
        let columnClassName = "recursiveBillingSetup-lastBilledDateDay justify-content-center";

        let options = [];
        for (let i = 1; i < 32; i++) {
            options.push(i);
        }
        options = func_validation.convertArrayToDropdownArrayFormat(options);

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Last Billed Date Day",
            // isHeaderColumnSortable: true,
            // sortValue: "lastBilledDateDay",
            id: "lastBilledDateDay",
            accessor: "LastBilledDateDay",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;
    
                let value = props?.cell?.value;
                let value_formatted = func_validation.isNumberValid(value)? value: "-";
                value_formatted = (rowDepth == 1)? "": value_formatted;

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        (value_formatted != "-")) {
                        setLastBilledDateDay(value_formatted);
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setLastBilledDateDay(1);
                    }
                }, [isUserInputDisplayVisible]);

                let display = isUserInputDisplayVisible? (
                    <Dropdown
                        selectedValueWrapperClassName={" recursiveBillingSetup-lastBilledDateDay-input "}
                        selectedValueClassName={"recursiveBillingSetup-lastBilledDateDay-inputText"}

                        options={options}
                        selectedValue_default={lastBilledDateDay}
                        onChange={setLastBilledDateDay}
                        isFormSubmissionAttempted={isFormSubmissionAttempted}
                        
                    />
                ):(
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                )

                return display;
            },
        }
    }

    function getColumns_nextBilledDatetime() {
        let columnClassName = "recursiveBillingSetup-nextBilledDatetime";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Next Billed Date",
            // isHeaderColumnSortable: true,
            // sortValue: "nextBilledDatetime",
            id: "nextBilledDatetime",
            accessor: "NextBilledDateTime",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;
    
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
                value_formatted = (rowDepth == 1)? "": value_formatted;
                let value_original = "";
                if (func_validation.isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) {
                    value_original = value_formatted;
                    value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");
                }

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        func_validation.isStringTrimNotEmpty(value_original)) {
                        setNextBilledDatetime(value_original);
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setNextBilledDatetime(currentDate_toString);
                    }
                }, [isUserInputDisplayVisible]);

                let display = isUserInputDisplayVisible? (
                    <div className={" recursiveBillingSetup-nextBilledDatetime-input "}>
                        <Datepicker
                            defaultDate={nextBilledDatetime}
                            handleOnChange={setNextBilledDatetime}
                            isConversionRequired_ISO8601
                        />
                    </div>
                ):(
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                )

                return display;
            },
        }
    }

    function getColumns_cutOffDate() {
        let columnClassName = "recursiveBillingSetup-cutOffDate";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Cut Off Date",
            // isHeaderColumnSortable: true,
            // sortValue: "cutOffDate",
            id: "cutOffDate",
            accessor: "CutOffDate",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;
    
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
                value_formatted = (rowDepth == 1)? "": value_formatted;
                let value_original = "";
                if (func_validation.isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) {
                    value_original = value_formatted;
                    value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");
                }

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        func_validation.isStringTrimNotEmpty(value_original)) {
                        setCutOffDate(value_original);
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setCutOffDate(currentDate_toString);
                    }
                }, [isUserInputDisplayVisible]);

                let display = isUserInputDisplayVisible? (
                    <div className={"recursiveBillingSetup-cutOffDate-input "}>
                        <Datepicker
                            defaultDate={cutOffDate}
                            dateFormat={"MM/yyyy"}
                            handleOnChange={setCutOffDate}
                            isConversionRequired_ISO8601 isMonthYear
                        />
                    </div>
                ):(
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                )

                return display;
            },
        }
    }

    function getColumns_isSuspense() {
        let columnClassName = "recursiveBillingSetup-isSuspense";

        let options = [ 
            {
                label: "Yes",
                value: true
            },
            {
                label: "No",
                value: false
            }
        ];

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Is Suspense",
            // isHeaderColumnSortable: true,
            // sortValue: "isSuspense",
            id: "isSuspense",
            accessor: "IsSuspense",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {                
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;
    
                let value = props?.cell?.value;
                let value_formatted = func_validation.isNotNullUndefined(value)? value: "-";
                value_formatted = (rowDepth == 1)? "": value_formatted;

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        (value_formatted != "-")) {
                        setIsSuspense(value_formatted);
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setIsSuspense(false);
                    }
                }, [isUserInputDisplayVisible]);

                let display = isUserInputDisplayVisible? (
                    <Dropdown
                        selectedValueWrapperClassName={" recursiveBillingSetup-isSuspense-input "}
                        selectedValueClassName={"recursiveBillingSetup-isSuspense-inputText"}

                        options={options}
                        selectedValue_default={isSuspense}
                        onChange={setIsSuspense}

                        isFormSubmissionAttempted={isFormSubmissionAttempted}

                        
                    />
                ):(
                    <div  className={"noWrap-text-ellipsis"}>{func_validation.getUserFriendlyTrueFalseDisplay(value_formatted + "")}</div>
                )

                return display;
            },
        }
    }    

    function getColumns_referenceValues() {
        let columnClassName = "recursiveBillingSetup-referenceValues";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Reference Value(s)",
            // isHeaderColumnSortable: true,
            // sortValue: "referenceValues",
            id: "referenceValues",
            accessor: "referenceValues",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let row = func_validation.getObjectPropertyValue(props, "row");
                let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
                let rowIndex = func_validation.getObjectPropertyValue(row, "index");
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;

                let subRows = func_validation.getObjectPropertyValue(row, "subRows");
                let subRows_formatted = [];
                if (func_validation.isArrayNotEmpty(subRows)) subRows_formatted = subRows[0];
                let subRowDetails = func_validation.getObjectPropertyValue(subRows_formatted, "original");
                let subRowValue = func_validation.getObjectPropertyValue(subRowDetails, "referenceValues");

                let value = props?.cell?.value;
                let value_formatted = func_validation.isNumberValid(value)? value:"-";
                value_formatted = (rowDepth == 1)? "": value_formatted;

                let isUserInputDisplayVisible = (isUserInputsVisible && isRowInputVisibilitySelected);

                // Default Input Values
                useEffect(() => {
                    if (isUpdateAccountFunction &&
                        isUserInputDisplayVisible &&
                        !isDefaultInputValuesSet &&
                        func_validation.isStringTrimNotEmpty(subRowValue)) {

                        setReferenceValue(subRowValue);
                        setIsDefaultInputValuesSet(true);
                    }
                    else if (isAddingAccountFunction) {
                        setReferenceValue("");
                    }
                }, [isUserInputDisplayVisible]);

                let display = isUserInputDisplayVisible? (
                    <FormInput_textarea
                        customInputClassName={" recursiveBillingSetup-referenceValues-input "}
                        inputValue_default={referenceValue}

                        isInputBlurHandlingRequired
                        handleInputBlurExtend={(value) => { setReferenceValue(value); }}

                        customErrorValidation={isFormSubmissionAttempted && ((isDefaultProduct && func_validation.isStringTrimNotEmpty(referenceValue)) ||
                                                (!isDefaultProduct && func_validation.isStringTrimEmpty(referenceValue)))}

                        isLabelOptional
                        isMarginBtmOptional isErrorMsgOptional
                    />
                ):(rowDepth == 0)? (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                ):(func_validation.isStringTrimNotEmpty(value))?(
                    value.split("\n").map((outlet, idx) => {
                        // Subrow
                        return (
                            <div className={"noWrap-text-ellipsis recursiveBillingSetup-subrow-referenceValuesColumn "} key={idx}>{outlet}</div>
                        )
                    })
                ):"";

                return display;
            },
            subCell: (outletList, rowIdx) => {
                if (func_validation.isStringTrimNotEmpty(outletList)) {

                    let outletListArray = outletList.split("\n");
                    return outletListArray.map((outlet, idx) => {
                        return (
                            <div className={"noWrap-text-ellipsis recursiveBillingSetup-subrow-referenceValuesColumn "} key={idx}>{outlet}</div>
                        )
                    });
                }    
                return "";
            }
        }
    }

    function getColumns_subsidiary() {
        let columnClassName = "recursiveBillingSetup-subsidiary";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Subsidiary",
            id: "subsidiary",
            accessor: "Subsidiary",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
    
                return (
                    <div className={"noWrap-text-ellipsis"}>
                        {value? value:"-"}
                    </div>
                );
            },
        }
    }

    function getColumns_remarks() {
        let columnClassName = "recursiveBillingSetup-remarks";
        
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Customer Note",
            id: "remarks",
            accessor: "remarks",
            bodyCellClassName: columnClassName + " ",
            Cell: (cellProps) => {
                let accountCode = cellProps?.row?.original?.AccountCode;
                let rowDepth = cellProps?.row?.depth;

                return (rowDepth === 0)? (
                    <div className={"remarks__content noWrap-text-ellipsis"}
                        onClick={() => {
                            if (setAccountCode_props) setAccountCode_props(accountCode);
                            if (setIsModalVisible_remarks) setIsModalVisible_remarks(true);
                            if (props.getRemarks) props.getRemarks(accountCode);
                        }}
                    >
                        View Details
                    </div>
                ):"";
            },
        }
    }

    function getColumns_SORef() {
        let columnClassName = "recursiveBillingSetup-soRef";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "SO Number Ref",
            id: "SalesOrderNumberRef",
            accessor: "SalesOrderNumberRef",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
    
                return (
                    <div className={"noWrap-text-ellipsis"}>
                        {value? value:"-"}
                    </div>
                );
            },
        }
    }

    function getColumns_firstRowAction() {
        return {
            Cell: () => {
                return (
                    <div className={"recursiveBillingSetup-input-action d-flex align-items-center justify-content-start"}>
                        {/* Submit */}
                        <div className={"recursiveBillingSetup-addAccountAction-submit text-center"}
                            onClick={() => { handleAddOrUpdateAccount(); }}
                        >
                            <FontAwesomeIcon icon={faCheck} /> {addAccount_requesting && <Spinner size={0} />}
                        </div>
        
                        {/* Cancel */}
                        <div className={"recursiveBillingSetup-addAccountAction-cancel text-center"}
                            onClick={() => { 
                                setIsUserInputsVisible(false); 
                                resetAllStates();
                            }}
                        >
                            <FontAwesomeIcon icon={faTimes} />
                        </div>
                    </div>
                );
            }
        }
    }

    function handleAddOrUpdateAccount(isUpdatingAccount, billingSetupId, billingSetupDetailsId) {
        let addAccount = func_validation.getObjectPropertyValue(props, "addAccount", () => {});
        let addAccount_validated = func_validation.isFunction(addAccount)? addAccount: () => {}; 

        let updateAccount = func_validation.getObjectPropertyValue(props, "updateAccount", () => {});
        let updateAccount_validated = func_validation.isFunction(updateAccount)? updateAccount: () => {};

        if (//(!isUpdatingAccount || 
              //  (isUpdatingAccount && func_validation.isNumberValid(billingSetupId) &&
                //    (isDefaultProduct || (!isDefaultProduct && func_validation.isNumberValid(billingSetupDetailsId))))) &&
            func_validation.isStringTrimNotEmpty(companyId) &&
            func_validation.isStringTrimNotEmpty(accountCode) &&
            // func_validation.isStringTrimNotEmpty(dealerCode) &&
            // func_validation.isStringTrimNotEmpty(salesPersonCode) &&
            func_validation.isStringTrimNotEmpty(productCode) &&
            func_validation.isStringTrimNotEmpty(productName) &&
            ((func_validation.isBooleanTrueNotNullUndefined(isDefaultProduct) && func_validation.isStringTrimEmpty(referenceValue)) ||
                (func_validation.isBooleanFalseNotNullUndefined(isDefaultProduct) && func_validation.isStringTrimNotEmpty(referenceValue))) &&
            func_validation.isStringTrimNotEmpty(chargeMethod) &&
            ((func_validation.isStringEqual_caseInsensitive(chargeMethod, "OutletTransaction") && func_validation.isNumberValid(transactionCountToCharge)) || 
                (!func_validation.isStringEqual_caseInsensitive(chargeMethod, "OutletTransaction"))) &&
            ((func_validation.isStringEqual_caseInsensitive(chargeMethod, "OutletPos") && func_validation.isNumberValid(posCountToCharge)) || 
                (!func_validation.isStringEqual_caseInsensitive(chargeMethod, "OutletPos"))) &&
            ((func_validation.isStringTrimNotEmpty(systemChargeMethodComment) && func_validation.isStringEqual_caseInsensitive(chargeMethod, "System")) ||
                func_validation.isStringTrimEmpty(systemChargeMethodComment)) &&
            func_validation.isStringTrimNotEmpty(subscriptionMethod) &&
            func_validation.isNumberValid(frequency) &&
            func_validation.isStringTrimNotEmpty(unitPrice) &&
            func_validation.isStringTrimNotEmpty(quantity) &&
            // func_validation.isNotNullUndefined(isAdvancePay) &&
            // func_validation.isStringTrimNotEmpty(unitDiscountAmount) &&
            func_validation.isNotNullUndefined(isBillInForeignCurrency) &&
            func_validation.isStringTrimNotEmpty(currencyCode) &&
            // func_validation.isStringTrimNotEmpty(currencyRate) &&
            func_validation.isStringTrimNotEmpty(lastBilledDatetime) &&
            func_validation.isNumberValid(lastBilledDateDay) &&
            func_validation.isStringTrimNotEmpty(nextBilledDatetime) &&
            // func_validation.isStringTrimNotEmpty(cutOffDate) &&
            func_validation.isNotNullUndefined(isSuspense)) {

            let referenceValues_formatted = func_validation.getTrimmedString(referenceValue, "");
            let referenceValueArray = referenceValues_formatted.split("\n");
            let billingSetupDetailsId_validated = func_validation.isNumberValid(billingSetupDetailsId)? billingSetupDetailsId:0;
            let billingSetupId_validated = func_validation.isNumberValid(billingSetupId)? billingSetupId:0;
            let companyId_formatted = func_validation.getParsedFormattedInt(companyId);

            let accountInfo = {
                Id: func_validation.isNumberValid(billingSetupId)? billingSetupId:0,
                CompanyId: companyId_formatted,
                AccountCode: accountCode,
                DealerCode: func_validation.isStringTrimNotEmpty(dealerCode)? dealerCode:"",
                SalesPersonCode: func_validation.isStringTrimNotEmpty(salesPersonCode)? salesPersonCode:"",
                ProductCode: productCode,
                ProductName: productName,
                IsDefaultProduct: isDefaultProduct,
                ChargeMethod: chargeMethod,
                POSCountToCharge: posCountToCharge,
                SystemChargeMethodComment: systemChargeMethodComment,
                SubscriptionMethod: subscriptionMethod,
                BillFrequence: parseInt(frequency),
                UnitPrice: func_validation.getParsedFormattedFloat(unitPrice),
                Quantity: func_validation.getParsedFormattedInt(quantity),
                IsAdvancePay: isAdvancePay,
                UnitDiscountAmount: func_validation.isStringTrimNotEmpty(unitDiscountAmount)? func_validation.getParsedFormattedFloat(unitDiscountAmount):0,
                IsBillInForeignCurrency: isBillInForeignCurrency,
                CurrencyCode: currencyCode,
                CurrencyRate: func_validation.isStringTrimNotEmpty(currencyRate)? func_validation.getParsedFormattedFloat(currencyRate):1,
                TransactionCountToCharge: transactionCountToCharge,
                LastBilledDateTime: lastBilledDatetime,
                LastBilledDateDay: lastBilledDateDay,
                NextBilledDateTime: nextBilledDatetime,
                CutOffDate: cutOffDate,
                IsSuspense: isSuspense,
                Remarks: remarks
            }


            if (func_validation.isArrayNotEmpty(referenceValueArray)) {
                let billingSetupDetails = [];
                let arraySize = referenceValueArray.length;
                for (let i = 0; i < arraySize; i++) {
                    let referenceValue = referenceValueArray[i];

                    if (func_validation.isStringTrimNotEmpty(referenceValue)) {
                        let billingSetupDetailsItem = {
                            Id: billingSetupDetailsId_validated,
                            BillingSetupId: billingSetupId_validated,
                            CompanyId: companyId_formatted,
                            ProductCode: productCode,
                            ReferenceKey: "",
                            ReferenceValue: referenceValue
                        };

                        billingSetupDetails.push(billingSetupDetailsItem);
                    }
                }

                if (func_validation.isArrayNotEmpty(billingSetupDetails)) {
                    accountInfo["BillingSetupDetails"] = billingSetupDetails;
                }
            }
            
            if (isUpdatingAccount) updateAccount_validated(accountInfo);
            else addAccount_validated(accountInfo);
        }
        setFormSubmissionStatus(true);
    }
    function handleDeleteAccount(companyId, accountCode, billingSetupId, rowIdx) {
        let deleteAccount = func_validation.getObjectPropertyValue(props, "deleteAccount", () => {});
        let deleteAccount_validated = func_validation.isFunction(deleteAccount)? deleteAccount: () => {}; 

        Swal.fire({
            html: "<React.Fragment><div>Deleting account:</div><div>CompanyID = " + companyId + "</div><div>AccountCode = " + accountCode + "</div></React.Fragment>",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            confirmButtonColor: color_failure,
            cancelButtonText: 'No, cancel!',
            reverseButtons: true
        }).then((result) => {
            if (result.value &&
                func_validation.isNumberValid(billingSetupId)) {
                setSelectedRowIdx(rowIdx);
                deleteAccount_validated(billingSetupId);
            }
        });
    }
    function getColumns_action(props) {
        let companyId = func_validation.getObjectPropertyValue(props, "companyId", "");
        let accountCode = func_validation.getObjectPropertyValue(props, "accountCode", "");
        let billingSetupId = func_validation.getObjectPropertyValue(props, "billingSetupId", "");
        let billingSetupDetailsId = func_validation.getObjectPropertyValue(props, "billingSetupDetailsId", "");

        let deleteAccount_requesting = func_validation.getObjectPropertyValue(props, "deleteAccount_requesting");
        let updateAccount_requesting = func_validation.getObjectPropertyValue(props, "updateAccount_requesting");

        let isMasterSet = func_validation.getObjectPropertyValue(props, "isMasterSet");
        let setMaster = func_validation.getObjectPropertyValue(props, "setMaster", () => {});
        let setMaster_validated = func_validation.isFunction(setMaster)? setMaster: () => {}; 

        return {
            Cell: (rowIndex) => {
                let isRowInputVisibilitySelected = func_validation.isNumberValid(rowIndex)? (inputVisibility_rowIndex == rowIndex): true;

                return (
                    <div className={"recursiveBillingSetup-actionColumn d-flex align-items-center justify-content-center"}>

                        {isUserInputsVisible && isRowInputVisibilitySelected? (
                            <React.Fragment>
                                {/* Update */}
                                <div className={"recursiveBillingSetup-actionColumn-update text-center"}
                                    onClick={() => { handleAddOrUpdateAccount(true, billingSetupId, /*billingSetupDetailsId*/); }}
                                >
                                    <FontAwesomeIcon icon={faCheck} /> {updateAccount_requesting && <Spinner size={0} />}
                                </div>
                
                                {/* Cancel */}
                                <div className={"recursiveBillingSetup-actionColumn-cancel text-center"}
                                    onClick={() => { 
                                        handleRowClickability(undefined);
                                        setIsUserInputsVisible(false);
                                        setInputVisibility_rowIndex(rowIndex);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faTimes} />
                                </div>
                            </React.Fragment>

                        ):(
                            <React.Fragment>
                                {/* Edit */}
                                <div className={"recursiveBillingSetup-actionColumn-edit text-center"}
                                    onClick={() => { 
                                        resetAllStates();
                                        handleRowClickability(rowIndex);
                                        setInputVisibility_rowIndex(rowIndex);
                                        setIsUserInputsVisible(true);
                                        setIsDefaultInputValuesSet(false);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faEdit} />
                                </div>
                
                                {/* Delete */}
                                <div className={"recursiveBillingSetup-actionColumn-delete text-center"}
                                    onClick={() => { handleDeleteAccount(companyId, accountCode, billingSetupId, rowIndex); }}
                                >
                                    <FontAwesomeIcon icon={faTrash} /> {deleteAccount_requesting && (selectedRowIdx == rowIndex) && <Spinner size={0} />}
                                </div>
                            </React.Fragment>
                        )}
        
                        {/* Set Master */}
                        {/* <div className={"recursiveBillingSetup-actionColumn-setMaster " + 
                                        (isMasterSet? "recursiveBillingSetup-actionColumn-setMaster_enabledBackgroundColor ":"")}
                            onClick={() => { setMaster_validated(accountCode_formatted); }}
                        >
                            Set Master
                        </div> */}
                    </div>
                );
            }
        }
    }

    function getFirstRowColumns(props) {
        return [
            getColumns_companyId(),
            getColumns_accountCode(),
            getColumns_dealerCode(),
            getColumns_salesPersonCode(),
            getColumns_productCode(),
            getColumns_productName(),
            getColumns_isDefaultProduct(),
            getColumns_chargeMethod(),
            getColumns_posCountToCharge(),
            getColumns_systemChargeMethodComment(),
            getColumns_subscriptionMethod(),
            getColumns_frequency(),
            getColumns_unitPrice(),
            getColumns_quantity(),
            getColumns_advancePay(),
            getColumns_unitDiscountAmount(),
            getColumns_isBillInForeignCurrency(),
            getColumns_currencyCode(),
            getColumns_currencyRate(),
            getColumns_transactionCountToCharge(),
            getColumns_lastBilledDatetime(),
            getColumns_lastBilledDateDay(),
            getColumns_nextBilledDatetime(),
            getColumns_cutOffDate(),
            getColumns_isSuspense(),
            getColumns_referenceValues(),
            getColumns_SORef(),
            getColumns_remarks(),
            getColumns_firstRowAction(),
        ]
    }

    function getColumns() {
        return [
            getColumns_companyId(),
            getColumns_accountCode(),
            getColumns_dealerCode(),
            getColumns_salesPersonCode(),
            getColumns_productCode(),
            getColumns_productName(),
            getColumns_isDefaultProduct(),
            getColumns_chargeMethod(),
            getColumns_posCountToCharge(),
            getColumns_systemChargeMethodComment(),
            getColumns_subscriptionMethod(),
            getColumns_frequency(),
            getColumns_unitPrice(),
            getColumns_quantity(),
            getColumns_advancePay(),
            getColumns_unitDiscountAmount(),
            getColumns_isBillInForeignCurrency(),
            getColumns_currencyCode(),
            getColumns_currencyRate(),
            getColumns_transactionCountToCharge(),
            getColumns_lastBilledDatetime(),
            getColumns_lastBilledDateDay(),
            getColumns_nextBilledDatetime(),
            getColumns_cutOffDate(),
            getColumns_isSuspense(),
            getColumns_referenceValues(),
            getColumns_subsidiary(),
            getColumns_SORef(),
            getColumns_remarks(),
        ];
    }

    return {
        // Columns Array
        getColumns,
        getFirstRowColumns,

        // Columns
        getColumns_companyId,
        getColumns_accountCode,
        getColumns_dealerCode,
        getColumns_salesPersonCode,
        getColumns_productCode,
        getColumns_productName,
        getColumns_isDefaultProduct,
        getColumns_chargeMethod,
        getColumns_posCountToCharge,
        getColumns_systemChargeMethodComment,
        getColumns_subscriptionMethod,
        getColumns_frequency,
        getColumns_unitPrice,
        getColumns_quantity,
        getColumns_advancePay,
        getColumns_unitDiscountAmount,
        getColumns_isBillInForeignCurrency,
        getColumns_currencyCode,
        getColumns_currencyRate,
        getColumns_transactionCountToCharge,
        getColumns_lastBilledDatetime,
        getColumns_lastBilledDateDay,
        getColumns_nextBilledDatetime,
        getColumns_cutOffDate,
        getColumns_isSuspense,
        getColumns_referenceValues,
        getColumns_remarks,
        getColumns_firstRowAction,
        getColumns_action,
        
        isAddAccountDisplayVisible: isUserInputsVisible, 
        setAddAccountDisplayVisibility: setIsUserInputsVisible
    }
}